import { Box, Typography } from "@mui/material";
import NavBar from "../Components/NavBar";
import Footer from "../Components/Footer";

const BoardOfDirectors = () => {
    return (
        <>
            <NavBar textColor="#000000" logoTextColor="#000000" />
            <Box>
                <Typography>WElcome</Typography>
            </Box>
            <Footer
                textColor="#000000"
                logoTextColor="#000000"
                headingColor="#2196F3"
            />
        </>
    )
}

export default BoardOfDirectors;